import { ToursCatalog, ToursSearch } from 'package-types';
import { DestinationSelectors } from 'package-angular';

export class SearchFormState {
  departureCities: ToursSearch.DepartureCity[] = [];
  departureCitiesStatus: 'idle' | 'loading' | 'ready' | 'error' = 'idle';
  departureCitiesLocationId?: number;
  destinationSelectors: DestinationSelectors = { resorts: [], hotels: [] };
  originalHotelsSelector: ToursCatalog.SelectiveHotel[] = [];
  selectors: ToursCatalog.SearchSelectors = {
    duration: [],
    food: [],
    services: [],
    transport: []
  };
}
